//Facility Administration
const AdminFacilities = () => import("../components/admin/AdminFacilities");
const AdminFacilitySearch = () =>
  import("../components/admin/AdminFacilitySearchForm");
const AdminFacilityDelete = () =>
  import("../components/admin/AdminFacilityDeleteForm");
const DataUploaderRequests = () =>
  import("../components/data-uploader/DataUploaderRequests.vue");
const RequestCalculationErrors = () =>
  import("../components/data-uploader/RequestCalculationErrors.vue");
const Problems = () => import("../components/problems/Problems.vue");
//Users Administration
const CreateAuthority = () =>
  import("../components/admin/user/CreateAuthority");
const SearchAuthority = () =>
  import("../components/admin/user/SearchAuthority");
const CreateUser = () => import("../components/admin/user/createUser.vue");
const EditUser = () => import("../components/admin/user/editUser");
const CreateUserType = () => import("../components/admin/user/createUserType");
const SearchUser = () => import("../components/admin/user/searchUser");
const LockedUsers = () => import("../components/admin/user/LockedUsers");
const Admin = () => import("../components/admin/Admin.vue");
const AdminMainPage = () => import("../components/admin/main.vue");
const AdminHomePage = () => import("../components/admin/AdminHomePage.vue");
const AdminCardsHome = () => import("../components/admin/AdminCardsHome");

//Sectors Administration
const CreateSectors = () => import("../components/admin/CreateSectors.vue");
const AddSector = () => import("../components/admin/AddSector.vue");
const AddSemiSector = () => import("../components/admin/AddSemiSector");
const AddSubSector = () => import("../components/admin/AddSubSector");
const CreatePollutant = () => import("../components/admin/CreatePollutant");
const CreateAgricultureAnimals = () =>
  import("../components/admin/agriculture/AddAgriculturalAnimals.vue");

const LawsandRegulations = () => import("../components/LawsAndRegulations.vue");
const ImportPage = () => import("../components/Import.vue");
const ImportInquiry = () => import("../components/ImportInquiry.vue");
const NotFoundComponent = () => import("../components/NotFound.vue");

//agriculture Administration
const AgriculturePollutionCalculations = () =>
  import(
    "../components/admin/agriculture/AgriculturePollutionCalculations.vue"
  );
const AgricultureRequests = () =>
  import("../components/admin/agriculture/AgricultureRequests.vue");
// const EditAgriculture = () =>
//   import("../components/admin/agriculture/EditAgriculture.vue");
// const EditAnimals = () =>
//   import("../components/admin/agriculture/EditAnimals.vue");
const SearchAgriculture = () =>
  import("../components/admin/agriculture/SearchAgriculture.vue");
const SearchAnimals = () =>
  import("../components/admin/agriculture/SearchAnimals.vue");
const SearchAgricultureCategories = () =>
  import("../components/admin/agriculture/SearchAgricultureCategories.vue");
const SearchAnimalsCategories = () =>
  import("../components/admin/agriculture/SearchAnimalsCategories.vue");
const ChatPage = () => import("../components/admin/ChatPage.vue");

// Industrial
const IndustrialPollutionCalculation = () =>
  import("../components/admin/industrial/IndustrialPollutionCalculation.vue");

// Oil and Gas
const OilAndGasPollutionCalculation = () =>
  import("../components/admin/oilAndGas/OilAndGasPollutionCalculation.vue");

// Others
const CalculateResidentialsAirPollution = () =>
  import("../components/admin/others/CalculateResidentialsAirPollution.vue");
const StoreResidentialsPowerConsumption = () =>
  import("../components/admin/others/StoreResidentialsPowerConsumption.vue");
const CalculateCommercialAirPollution = () =>
  import("../components/admin/others/CalculateCommercialAirPollution.vue");
const StoreCommercialPowerConsumption = () =>
  import("../components/admin/others/StoreCommercialPowerConsumption.vue");
const StartDataRequestCalculations = () =>
  import("../components/admin/others/StartDataRequestCalculations.vue");

// Solid Waste
const SolidWasteEfficiency = () =>
  import("../components/agriculture user/SolidWasteEfficiency.vue");
const SWGenerationManagement = () =>
  import("../components/reports/SWGenerationManagement.vue");
const SolidWasteOtherCalculations = () =>
  import("../components/admin/solidwaste/SolidWasteOtherCalculations.vue");

import { userTypes } from "./userTypes";

export default [
  {
    name: "Admin",
    path: "/admin",
    component: AdminMainPage,
    meta: {
      requiresAuth: true,
      allowedUsers: [
        userTypes.Super,
        userTypes.Admin,
        userTypes.ITAdmin,
        userTypes.ContentCreator,
        userTypes.DecisionMaker,
      ],
    },
    children: [
      {
        path: "home",
        meta: {
          requiresAuth: true,
          allowedUsers: [
            userTypes.Super,
            userTypes.Admin,
            userTypes.ITAdmin,
            userTypes.ContentCreator,
            userTypes.DecisionMaker,
          ],
        },
        component: Admin,
        children: [
          {
            name: "AdminHome",
            path: "stats",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            component: AdminHomePage,
          },
          {
            name: "CreateAuthority",
            path: "/user/authority",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            component: CreateAuthority,
            props: true,
          },
          {
            name: "SearchAuthority",
            path: "/user/searchauthority",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            component: SearchAuthority,
          },
          {
            name: "CreateUser",
            path: "/user/create",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            component: CreateUser,
          },

          {
            name: "EditUser",
            path: "/user/Edit",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            component: EditUser,
          },
          {
            name: "CreateUserType",
            path: "/user/type/create",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            component: CreateUserType,
          },
          {
            name: "SearchUser",
            path: "/user/search",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            component: SearchUser,
          },
          {
            name: "LockedUsers",
            path: "/user/locked",
            meta: {
              requiresAuth: true,
              allowedUsers: [userTypes.Super, userTypes.Admin, userTypes.ITAdmin],
            },
            component: LockedUsers,
          },
          {
            name: "AdminCreateFacility",
            path: "/facility/create",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            component: AdminFacilities,
            props: { show: "createFacility" },
          },
          {
            name: "EditFacility",
            path: "/facility/edit",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            component: AdminFacilities,
            props: { show: "editFacility" },
          },
          {
            name: "SearchFacility",
            path: "/facility/search",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.WaterUser,
                userTypes.AirUser,
              ],
            },
            component: AdminFacilitySearch,
          },
          {
            name: "DeleteFacility",
            path: "/facility/delete",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
              ],
            },
            component: AdminFacilityDelete,
          },
          {
            name: "CreateSector",
            path: "/Sector/create",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
              ],
            },
            component: AddSector,
            props: true,
          },
          {
            name: "AddSector",
            path: "/Sector/create",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
              ],
            },
            component: CreateSectors,
          },

          {
            name: "EditSector",
            path: "/Sector/Edit",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
              ],
            },
            component: CreateSectors,

            props: true,
          },
          // {
          //   name: "EditSemiSector",
          //   path: "/Sector/industrialsectors/Edit",
          //   meta: {
          //     requiresAuth: true,
          //     allowedUsers: [
          //       userTypes.Super,
          //       userTypes.Admin,
          //       userTypes.ContentCreator,
          //       userTypes.DecisionMaker,
          //     ],
          //   },
          //   component: CreateSectors,
          //   props: true,
          // },
          // {
          //   name: "CreateIndustrialSemiSector",
          //   path: "/Sector/industrialsectors/create",
          //   meta: {
          //     requiresAuth: true,
          //     allowedUsers: [
          //       userTypes.Super,
          //       userTypes.Admin,
          //       userTypes.ContentCreator,
          //       userTypes.DecisionMaker,
          //     ],
          //   },
          //   component: CreateSectors,
          // },
          // {
          //   name: "AddIndustrialSemiSector",
          //   path: "/Sector/industrialsectors/Add",
          //   meta: {
          //     requiresAuth: true,
          //     allowedUsers: [
          //       userTypes.Super,
          //       userTypes.Admin,
          //       userTypes.ContentCreator,
          //       userTypes.DecisionMaker,
          //     ],
          //   },
          //   component: AddSemiSector,
          // },
          {
            name: "AddSubSector",
            path: "/Sector/subsectors/create",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
              ],
            },
            component: AddSubSector,
            props: true,
          },
          {
            name: "CreateSubSector",
            path: "/Sector/subsectors/create",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
              ],
            },
            component: CreateSectors,
            props: true,
          },
          {
            name: "EditSubSector",
            path: "/Sector/Edit",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
              ],
            },
            component: CreateSectors,

            props: true,
          },
          {
            name: "CreatePollutant",
            path: "/Sector/pollutant/create",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
              ],
            },
            component: CreatePollutant,
            props: { show: "createPollutant" },
          },
          {
            name: "CreateAgricultureAnimals",
            path: "/AgricultureAnimals/agricultureAnimals/create",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
              ],
            },
            component: CreateAgricultureAnimals,
            props: true,
          },
          // {
          //   name: "EditAgriculture",
          //   path: "/AgricultureAnimals/EditAgriculture",
          //   meta: {
          //     requiresAuth: true,
          //     allowedUsers: [
          //       userTypes.Super,
          //       userTypes.Admin,
          //       userTypes.DataVerifier,
          //       userTypes.AgricultureUser,
          //     ],
          //   },
          //   component: EditAgriculture,
          //   props: true,
          // },
          {
            name: "SearchAgricultureCategories",
            path: "/AgricultureAnimals/SearchAgricultureCategories",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
                userTypes.AgricultureUser,
              ],
            },
            component: SearchAgricultureCategories,
            props: true,
          },
          {
            name: "SearchAnimalsCategories",
            path: "/AgricultureAnimals/SearchAnimalsCategories",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
                userTypes.AgricultureUser,
              ],
            },
            component: SearchAnimalsCategories,
            props: true,
          },
          {
            name: "SearchAgriculture",
            path: "/AgricultureAnimals/searchagriculture",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
                userTypes.AgricultureUser,
              ],
            },
            component: SearchAgriculture,
            props: true,
          },
          {
            name: "SearchAnimals",
            path: "/AgricultureAnimals/searchanimals",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
                userTypes.AgricultureUser,
              ],
            },
            component: SearchAnimals,
            props: true,
          },
          // {
          //   name: "EditAnimals",
          //   path: "/AgricultureAnimals/EditAnimals",
          //   meta: {
          //     requiresAuth: true,
          //     allowedUsers: [
          //       userTypes.Super,
          //       userTypes.Admin,
          //       userTypes.DataVerifier,
          //       userTypes.AgricultureUser,
          //     ],
          //   },
          //   component: EditAnimals,
          //   props: true,
          // },
          {
            name: "AgriculturePollutionCalculations",
            path: "/AgricultureAnimals/AgriculturePollutionCalculations",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
              ],
            },
            component: AgriculturePollutionCalculations,
            props: { superId: 1 },
          },
          {
            name: "SewagePollutionCalculations",
            path: "/AgricultureAnimals/SewagePollutionCalculations",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
              ],
            },
            component: AgriculturePollutionCalculations,
            props: { filterId: 4, superId: 1 },
          },
          {
            name: "CreateRegulations",
            path: "/regulations/create",
            component: LawsandRegulations,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: { type: "create" },
          },
          {
            name: "DeleteRegulations",
            path: "/regulations/delete",
            component: LawsandRegulations,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: { type: "delete" },
          },
          {
            name: "AdminDataUploaderRequests",
            path: "/data/admin/data-uploader-requests",
            component: DataUploaderRequests,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.DataUploader,
              ],
            },
          },
          {
            name: "AdminRequestCalculationErrors",
            path: "/data/admin/data-uploader-requests/:requestId/errors",
            component: RequestCalculationErrors,
            props: true,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.DataUploader,
              ],
            },
          },
          {
            name: "IndustrialPollutionCalculation",
            path: "/industrial/IndustrialPollutionCalculation",
            component: IndustrialPollutionCalculation,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
              ],
            },
          },
          {
            name: "OilAndGasPollutionCalculation",
            path: "/oilAndGas/OilAndGasPollutionCalculation",
            component: OilAndGasPollutionCalculation,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
              ],
            },
          },
          {
            name: "OilAndGasImportFacilities",
            path: "/oilAndGas/refineries",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: {
              type: "Facilities",
              isAdmin: true,
              superId: 10,
              template: "RefineriesData.xlsx",
            },
          },
          {
            name: "PowerPlantsImportFacilities",
            path: "/powerplants/refineries",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: {
              type: "Facilities",
              isAdmin: true,
              superId: 6,
              template: "PowerPlantsData.xlsx",
            },
          },
          {
            name: "CalculateResidentialsAirPollution",
            path: "/residential/CalculateResidentialsAirPollution",
            component: CalculateResidentialsAirPollution,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
              ],
            },
          },
          {
            name: "StoreResidentialsPowerConsumption",
            path: "/residential/StoreResidentialsPowerConsumption",
            component: StoreResidentialsPowerConsumption,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
              ],
            },
          },
          {
            name: "CalculateCommercialAirPollution",
            path: "/commercial/CalculateCommercialAirPollution",
            component: CalculateCommercialAirPollution,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
              ],
            },
          },
          {
            name: "StoreCommercialPowerConsumption",
            path: "/commercial/StoreCommercialPowerConsumption",
            component: StoreCommercialPowerConsumption,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
              ],
            },
          },
          {
            name: "StartDataRequestCalculations",
            path: "/others/StartDataRequestCalculations",
            component: StartDataRequestCalculations,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
              ],
            },
          },
            {
              name: "Problems",
              path: "/others/problems",
              meta: {
                requiresAuth: true,
                allowedUsers: [
                  userTypes.Super,
                  userTypes.Admin,
                  userTypes.DataVerifier,
                  userTypes.FormFillerSuperVisor,
                ],
              },
              component: Problems,
            },
          {
            name: "ImportFacilities",
            path: "/industrial/facilities",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.DataCollector,
              ],
            },
            props: {
              type: "Facilities",
              isAdmin: true,
              superId: 7,
              template: "FacilitiesData.xlsx",
            },
          },
          {
            name: "ImportScannedFacilities",
            path: "/importFiles/facilities/scanned",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.DataCollector,
              ],
            },
            props: { type: "ScannedFacilities", isAdmin: true },
          },
          {
            name: "ImportSectorRules",
            path: "/industrial/importFiles/sectorrules",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: { type: "SectorRules", isAdmin: true },
          },
          {
            name: "ImportProductAndSectorCodes",
            path: "/industrial/importFiles/productData",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.DataCollector,
              ],
            },
            props: {
              type: "ProductAndSectorCodes",
              isAdmin: true,
              superId: 7,
              template: "ISICData.xlsx",
            },
          },
          {
            name: "ImportIndustrialNFRs",
            path: "/industrial/importFiles/nfrs",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: {
              type: "IndustrialNFRs",
              isAdmin: true,
              superId: 7,
              template: "NFRsData.xlsx",
            },
          },
          {
            name: "IndustrialAirImportEmissionFactors",
            path: "/industrial/importFiles/industrialAirEmissionFactors",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.DataCollector,
              ],
            },
            props: {
              type: "EmissionFactors",
              isAdmin: true,
              superId: 7,
              template: "IndustrialAirEmissionFactorsData.xlsx",
              emissionsType: "industrialair"
            },
          },
          {
            name: "EnergyAirImportEmissionFactors",
            path: "/industrial/importFiles/energyAirEmissionFactors",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.DataCollector,
              ],
            },
            props: {
              type: "EmissionFactors",
              isAdmin: true,
              superId: 7,
              template: "EnergyAirEmissionFactorsData.xlsx",
              emissionsType: "industrialenergy"
            },
          },
          {
            name: "WaterImportEmissionFactors",
            path: "/industrial/importFiles/waterEmissionFactors",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.DataCollector,
              ],
            },
            props: {
              type: "EmissionFactors",
              isAdmin: true,
              superId: 7,
              template: "WaterEmissionFactorsData.xlsx",
              emissionsType: "industrialwater"
            },
          },
          {
            name: "ImportIndustrialAssumptions",
            path: "/industrial/importFiles/assumptions",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: {
              type: "IndustrialAssumptions",
              isAdmin: true,
              superId: 7,
              template: "AssumptionsData.xlsx",
            },
          },
          {
            name: "ImportOilAndGas",
            path: "/OilAndGas/importFiles/oilAndGas",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: {
              type: "OilAndGas",
              isAdmin: true,
              superId: 10,
              template: "OilAndGasData.xlsx",
              label: "Oil and Gas",
            },
          },
          {
            name: "ImportControl",
            path: "/importFiles/control",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: { type: "Control", isAdmin: true },
          },
          {
            name: "ImportFuel",
            path: "/importFiles/fuel",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: { type: "Fuel", isAdmin: true },
          },
          {
            name: "ImportAgriculture",
            path: "/importFiles/agriculture",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: {
              type: "Agriculture",
              isAdmin: true,
            },
          },
          {
            name: "ImportCategories",
            path: "/importFiles/categories",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.ITAdmin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: { type: "Categories", isAdmin: true },
          },
          {
            name: "ImportGovernorate",
            path: "/importMaps/governorate",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [userTypes.Super, userTypes.ITAdmin],
            },
            props: { type: "GovernorateMap", isAdmin: true, borderLevel: 0 , template: "GovernorateMap.png" },
          },
          {
            name: "ImportMrkaz",
            path: "/importMaps/mrkaz",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [userTypes.Super, userTypes.ITAdmin],
            },
            props: { type: "MrkazMap", isAdmin: true, borderLevel: 1, template: "MrkazMap.png" },
          },
          {
            name: "ImportShyakha",
            path: "/importMaps/district",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [userTypes.Super, userTypes.ITAdmin],
            },
            props: { type: "ShyakhaMap", isAdmin: true, borderLevel: 2, template: "ShyakhaMap.png"},
          },
          {
            name: "ImportIndustrialZone",
            path: "/importMaps/IndustrialZones",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [userTypes.Super, userTypes.ITAdmin],
            },
            props: { type: "ZoneMap", isAdmin: true, borderLevel: 4, template: "ZoneMap.png" },
          },
          {
            name: "ImportSewage",
            path: "/importMaps/SewageCoverage",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [userTypes.Super, userTypes.ITAdmin],
            },
            props: { type: "SewageMap", isAdmin: true, borderLevel: 3, template: "SewageMap.png" },
          },

          // {
          //   name: "ImportPbf",
          //   path: "/importMaps/pbf",
          //   component: ImportPage,
          //   meta: {
          //     requiresAuth: true,
          //     allowedUsers: [userTypes.Super, userTypes.Admin],
          //   },
          //   props: { type: "Pbf", isAdmin: true },
          // },
          {
            name: "ImportAgricultureSector",
            path: "/AgricultureAnimals/SectorFile",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.AgricultureUser,
              ],
            },
            props: {
              type: "SectorAndData",
              isAdmin: true,
              superId: 1,
              template: "AgricultureSectors.xlsx",
            },
          },
          {
            name: "ImportAgricultureData",
            path: "/AgricultureAnimals/agricultureDataFile",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.AgricultureUser,
              ],
            },
            props: {
              type: "SectorAndData",
              isAdmin: true,
              superId: 1,
              template: "AgricultureData.xlsx",
            },
          },
          {
            name: "ImportAgricultureLookupData",
            path: "/AgricultureAnimals/agricultureLookupFile",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.AgricultureUser,
              ],
            },
            props: {
              type: "agricultureFileLookup",
              isAdmin: true,
              superId: 1,
              template: "LivestockDistributionData.xlsx",
            },
          },
          {
            name: "ImportAgricultureCalculate",
            path: "/AgricultureAnimals/agricultureEquations",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.AgricultureUser,
              ],
            },
            props: {
              type: "equation",
              superId: 1,
              template: "AgricultureEquations.xlsx",
              isAdmin: true,
            },
          },

          {
            name: "ImportFactories",
            path: "/importFiles/facilities/factories",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: { type: "Factories", isAdmin: true },
          },
          {
            name: "sw-efficiency",
            path: "reports/sw-efficiency",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.DecisionMaker,
                userTypes.DataVerifier,
                userTypes.WasteUser,
              ],
            },
            component: SolidWasteEfficiency,
            props: {
              name: "SolidWaste Efficiency",
              superId: 4,
              hideHeader: false,
            },
          },
          {
            name: "sw-generation-management",
            path: "reports/sw-generation-management",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.DecisionMaker,
                userTypes.DataVerifier,
                userTypes.WasteUser,
              ],
            },
            component: SWGenerationManagement,
            props: {
              name: "SolidWaste Management",
              superId: 4,
              hideHeader: false,
            },
          },
          {
            name: "CompostingImportFacilities",
            path: "data/SolidWaste/composting",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.WasteUser
              ],
            },
            props: {
              type: "Facilities",
              isAdmin: true,
              superId: 4,
              template: "CompostingData.xlsx",
            },
          },
          {
            name: "LandfillsImportFacilities",
            path: "data/SolidWaste/landfills",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.WasteUser
              ],
            },
            props: {
              type: "Facilities",
              isAdmin: true,
              superId: 4,
              template: "LandfillsData.xlsx",
            },
          },
          {
            name: "WWTPImportFacilities",
            path: "/sewage/wwtp",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
              ],
            },
            props: {
              type: "Facilities",
              isAdmin: true,
              superId: 5,
              template: "wwtpData.xlsx",
            },
          },
          {
            name: "SolidWasteImportFile",
            path: "/SolidWaste/annualData",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker,
                userTypes.WasteUser
              ],
            },
            props: {
              type: "SectorAndData",
              isAdmin: true,
              superId: 4,
              template: "SolidWasteMiscData.xlsx",
            },
          },

          {
            name: "SolidWasteImportSectorFile",
            path: "/SolidWaste/SectorFile/",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.WasteUser,
                userTypes.WasteUser,
              ],
            },
            props: {
              type: "SectorAndData",
              isAdmin: true,
              superId: 4,
              template: "SolidWasteSectors.xlsx",
            },
          },
          {
            name: "SolidWasteImportEquations",
            path: "/SolidWaste/equations/",
            component: ImportPage,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.WasteUser,
              ],
            },
            props: {
              type: "equation",
              isAdmin: true,
              superId: 4,
              template: "SolidWasteEquations.xlsx",
            },
          },
          {
            name: "SolidWastePollutionCalculations",
            path: "/SolidWaste/calculation/SolidWastePollutionCalculations",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
                userTypes.WasteUser
              ],
            },
            component: AgriculturePollutionCalculations,
            props: { type: "solidWasteCalculate", isAdmin: true, superId: 4 },
          },
          {
            name: "SolidWasteOtherCalculations",
            path: "/SolidWaste/calculation/OtherCalculations",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
                userTypes.WasteUser
              ],
            },
            component: SolidWasteOtherCalculations,
          },
          {
            name: "ImportInquiry",
            path: "/import/inquiry",
            component: ImportInquiry,
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.ContentCreator,
                userTypes.DecisionMaker
              ],
            },
          },
          {
            name: "Admin_Requests",
            path: "/AgricultureAnimals/requests/Requests",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
                userTypes.AgricultureUser,
              ],
            },
            component: AgricultureRequests,
            props: { type: "Admin" },
          },
          {
            name: "Admin_chat",
            path: "/AgricultureAnimals/requests/chat",
            meta: {
              requiresAuth: true,
              allowedUsers: [
                userTypes.Super,
                userTypes.Admin,
                userTypes.DataVerifier,
                userTypes.AgricultureUser,
              ],
            },
            component: ChatPage,
            props: { type: "Admin" },
          },
        ],
      },
    ],
  },
];
